import { NgModule } from '@angular/core';

import { MonitoringRoutingModule } from './monitoring-routing.module';
import { TrainTreeStructureComponent } from './components/train-tree-structure/train-tree-structure.component';
import { SharedModule } from '../../shared/shared.module';
import { UIRouterModule } from '@uirouter/angular';
import { SimsModule } from '../sims/sims.module';
import { ReferenceAreasModule } from '../reference-areas/reference-areas.module';

import { MonitoredTrainsTableComponent } from './components/monitored-trains-table/monitored-trains-table.component';
import { MonitoredTrainsTilesComponent } from './components/monitored-trains-tiles/monitored-trains-tiles.component';
import { MONITORING_STATES } from './monitoring.states';
import { MonitoringFaultComponent } from './containers/monitoring-fault/monitoring-fault.component';
import { FaultFiltersComponent } from './components/fault-filters/fault-filters.component';
import { MonitoredTrainAlarmsComponent } from './components/monitored-train-alarms/monitored-train-alarms.component';
import { MonitoredTrainComponent } from './containers/monitored-train/monitored-train.component';
import { MonitoredTrainSummaryComponent } from './components/monitored-train-summary/monitored-train-summary.component';
import { MonitoredTrainSimComponent } from './components/monitored-train-sim/monitored-train-sim.component';
import { MonitoredTrainSynchronizationComponent } from './components/monitored-train-synchronization/monitored-train-synchronization.component';
import { MonitoredTrainsMapComponent } from './components/monitored-trains-map/monitored-trains-map.component';
import { MonitoredTrainsCdcAlarmsComponent } from './components/monitored-trains-cdc-alarms/monitored-trains-cdc-alarms.component';
import { FilterAlarmByCategoryPipe } from './pipes/filter-alarm-by-category.pipe';
import { TrainSyncStatusColorPipe } from './pipes/train-sync-status-color.pipe';
import { MonitoredTrainCanvasComponent } from './components/monitored-train-canvas/monitored-train-canvas.component';
import { MonitoredTrainSummaryUpgradedComponent } from './components/monitored-train-summary-upgraded/monitored-train-summary-upgraded.component';
import { MonitoredTrainsMapUpgradedComponent } from './components/monitored-trains-map-upgraded/monitored-trains-map-upgraded.component';
import { RemoveUnknownLocationPipe } from './pipes/remove-unknown-location.pipe';
import { CreateMapIconPipe } from './pipes/create-map-icon.pipe';
import { MonitoringOverviewComponent } from './containers/monitoring-overview/monitoring-overview.component';
import { MonitoredTrainInfoComponent } from './components/monitored-train-info/monitored-train-info.component';
import { MapTrainSearchPipe } from './pipes/map-train-search.pipe';
import { FilterAlarmActionsPipe } from './pipes/filter-alarm-actions.pipe';
import { HasUnacknowledgedAlarmsPipe } from './pipes/has-unacknowledged-alarms.pipe';
import { TrainStructurePipe } from './pipes/train-structure.pipe';
import { MonitoredTrainEventsComponent } from './components/monitored-train-events/monitored-train-events.component';
import { HasZabbixUrlPipe } from './pipes/has-zabbix-url.pipe';
import { FormatTrainTableDataPipe } from './pipes/format-train-table-data.pipe';
import { FormatAlarmTableDataPipe } from './pipes/format-alarm-table-data.pipe';
import { CalculateAlarmStatsPipe } from './pipes/calculate-alarm-stats.pipe';
import { ReferenceAreaColorPipe } from './pipes/reference-area-color.pipe';
import { FilterReferencePipe } from './pipes/filter-reference.pipe';
import { TrainsModule } from '../trains/trains.module';
import { TrainUsersCountPipe } from './pipes/train-users-count.pipe';
import { IncidentsModule } from '../incidents/incidents.module';
import { CanRaiseIncidentPipe } from './pipes/can-raise-incident.pipe';
import { FilterSatellitePipe} from "./pipes/filter-satellite.pipe";
import { ShowDevicePropertyPipe } from './pipes/show-device-property.pipe';
import { TreeDeviceTootipPipe } from './pipes/tree-device-tootip.pipe';
import { TrainTreeStructurePipe } from './pipes/train-tree-structure.pipe';
import { TrainCanvasPipe } from './pipes/train-canvas.pipe';
import { MonitoredTrainDevicesComponent } from './components/monitored-train-devices/monitored-train-devices.component';
import { WebsiteLinkDisabledReasonPipe } from './pipes/website-link-disabled-reason.pipe';

@NgModule({
  declarations: [
    TrainTreeStructureComponent,
    MonitoredTrainsTableComponent,
    MonitoredTrainsTilesComponent,
    MonitoringFaultComponent,
    FaultFiltersComponent,
    MonitoredTrainAlarmsComponent,
    MonitoredTrainComponent,
    MonitoredTrainSummaryComponent,
    MonitoredTrainSimComponent,
    MonitoredTrainSynchronizationComponent,
    MonitoredTrainsMapComponent,
    MonitoredTrainsCdcAlarmsComponent,
    FilterAlarmByCategoryPipe,
    TrainSyncStatusColorPipe,
    MonitoredTrainCanvasComponent,
    MonitoredTrainSummaryUpgradedComponent,
    MonitoredTrainsMapUpgradedComponent,
    RemoveUnknownLocationPipe,
    CreateMapIconPipe,
    MonitoringOverviewComponent,
    MonitoredTrainInfoComponent,
    MapTrainSearchPipe,
    FilterAlarmActionsPipe,
    HasUnacknowledgedAlarmsPipe,
    TrainStructurePipe,
    MonitoredTrainEventsComponent,
    HasZabbixUrlPipe,
    FormatTrainTableDataPipe,
    FormatAlarmTableDataPipe,
    CalculateAlarmStatsPipe,
    ReferenceAreaColorPipe,
    FilterReferencePipe,
    TrainUsersCountPipe,
    CanRaiseIncidentPipe,
    FilterSatellitePipe,
    ShowDevicePropertyPipe,
    TreeDeviceTootipPipe,
    TrainTreeStructurePipe,
    TrainCanvasPipe,
    MonitoredTrainDevicesComponent,
    WebsiteLinkDisabledReasonPipe
  ],
    imports: [
        MonitoringRoutingModule,
        SharedModule,
        UIRouterModule.forChild ( {states: [...MONITORING_STATES]} ),
        SimsModule,
        ReferenceAreasModule,
        TrainsModule,
        IncidentsModule
    ],
  entryComponents: [
    TrainTreeStructureComponent,
    MonitoredTrainsTableComponent
  ], 
  providers: [TrainTreeStructurePipe]
})
export class MonitoringModule { }
